/* ============================================================================
 * ICON — รหัสตัวอักษร FontAwesome (fa-light-300) ที่ใช้ในหน้าเว็บขาย
 * เก็บเป็น \u escape เพื่อให้อ่านออกในโค้ด (ถ้าใส่อักขระตรง ๆ จะมองไม่เห็นในโปรแกรมแก้ไข)
 * ใช้คู่กับ <span className="hm-ico">{ICON.search}</span>
 *
 * ★ เก็บเฉพาะคีย์ที่ถูกเรียกจริง — ไอคอนของหมวดหมู่/ไลฟ์สไตล์/บทความจากชุดต้นแบบลบออกแล้ว
 *   ไอคอนที่ผู้ดูแลตั้งเอง (shortcut / highlight / social) มาเป็นตัวอักษรจาก API ไม่ได้ผ่านไฟล์นี้
 * NOTE : ไอคอนโซเชียลใช้ไอคอนทั่วไปแทน (globe / comment / camera)
 * ========================================================================== */
const ICON = {
  search: "",
  chevron_left: "",
  chevron_right: "",
  chevron_down: "",
  chevron_up: "",
  chevron_right_small: "",
  marker: "",
  building: "",
  money: "",
  bed: "",
  bath: "",
  area: "",
  floor: "",
  eye: "",
  clock: "",
  phone: "",
  mail: "",
  headset: "",
  check: "",
  bars: "",
  close: "",
  bolt: "",
  home: "",
  file: "",
  tag: "",
  crown: "",
  shield: "",
  star: "",
  paw: "",
  globe: "",
  camera: "",

  /* ---- หน้ารายละเอียดทรัพย์ (/room) ---- */
  car: "",
  calendar: "",
  map: "",
  image: "",
  play: "",
  external: "",
  comment: "",
  tree: "",
  ruler: "",
  key: "",
  info: "",
};

export default ICON;
